<template>
    <div>
        <div class="loader-container" v-if="!loaded">
            <div class="loader"></div>
        </div>
        <b-list-group v-if="!praticheList.length && loaded">
            <b-list-group-item variant="secondary"><span>Non ci sono bolle da visualizzare.</span></b-list-group-item>
        </b-list-group>
        <b-list-group v-for="lista in praticheList" :key="lista.pratiche[0].uid" class="list-group">
            <span>{{monthsDictionary[lista.month - 1] + " / " + lista.year}}</span>
            <div class="list">
                <b-list-group-item button class="list-item" v-for="pratica in lista.pratiche" :key="pratica.uid" @click="goToPratica(pratica)" >
                    <b-row>
                        <b-col md="4" class="list-item-left"><span> {{pratica.nome}}</span></b-col>
                        <b-col md="4" class="list-item-center"><span> {{pratica.laboratorio.username}}</span></b-col>
                        <b-col md="4" class="d-flex justify-content-between align-items-center">
                            <img v-if="pratica.conclusa" src="@/assets/complete-primary.svg" class="verified-img" />
                            <img v-if="!pratica.conclusa" src="@/assets/complete-secondary.svg" class="verified-img" />
                            <span v-if="pratica.ultima_bolla"><small>Ultima bolla: </small> {{format_date(pratica.ultima_bolla)}}</span>
                        </b-col>
                    </b-row>
                </b-list-group-item>
            </div>
        </b-list-group>
        <b-list-group v-if="praticheListNoBolla.pratiche" class="list-group">
            <span>Pratiche senza bolle</span>
            <div class="list">
                <b-list-group-item button class="list-item" v-for="pratica in praticheSenzaBolle.pratiche" :key="pratica.uid" @click="goToPratica(pratica)">
                    <b-row>
                        <b-col class="list-item-left"><span> {{pratica.nome}}</span></b-col>
                        <b-col class="list-item-center"><span> {{pratica.laboratorio.username}}</span></b-col>
                        <b-col class="list-item-right"></b-col>
                    </b-row>
                </b-list-group-item>
            </div>
        </b-list-group>
        <div class="load-more" v-show="showLoadMore && loaded">
            <b-overlay
                :show="loadingMore"
                rounded
                opacity="0.4"
                spinner-small
                spinner-variant="secondary"
                class="d-inline-block"
            >
                <b-button class="load-more-button" variant="light" @click="loadPratiche()">Carica più risultati...</b-button>
            </b-overlay>
            <!-- <span v-show="!showLoadMore">Non ci sono altri risultati</span> -->
        </div>
    </div>
</template>

<script>
import {mixins} from '@/mixins';
export default {
    name: "ListaPraticheDottore",
    data(){
        return {
            searchResults: [],
            praticheSenzaBolle: [],
            loadCounter: 0,
            monthsDictionary: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
            loaded: false,
            showLoadMore: true,
            loadingMore: false,
        }
    },
    computed: {
        praticheList: function() {
            return this.searchResults;
        },
        praticheListNoBolla: function() {
            return this.praticheSenzaBolle;
        }
    },
    props:{
        id_dottore: String,
    },
    mixins: [mixins],
    mounted(){
        this.loadPratiche();
    },
    methods: {
        processResults: function(data){
            if(!data){
                this.showLoadMore = false;
            } 
            for (var group of data){
                if(!group.month){
                    this.praticheSenzaBolle = group;
                    this.showLoadMore = false;
                    break;
                }
                else{
                    this.searchResults = this.searchResults.concat(group);
                }
            }
        },
        loadPratiche: function(){
            this.loadingMore = true;
            this.$axios
            .get(this.$apibase + '/api/pratica/get_pratiche_by_doctor/',
                {
                    headers:{
                        Authorization:"JWT " + localStorage.getItem('access_token')
                    },
                    params: {
                        "dottore": this.id_dottore,
                        "counter": this.loadCounter,
                        "window": 2
                    }
                }
            )
            .then((response) => {
                this.processResults(response.data)
                this.loadingMore = false;
                this.loadCounter++;
                this.loaded = true;
            })
            .catch((e)=>{
                if (e.response.status == 403)
                    this.logout();
                else
                    alert(e.response);
            })
        },
        goToPratica: function(pratica){
            if (pratica.ultima_bolla)
                this.$router.push('/bolle/' + pratica.nome + '~' + pratica.uid)
        },
    }
}
</script>

<style scoped>
    .list{
        padding-top:20px;
    }
    .list-group{
        margin-bottom: 35px;
        text-align: left;
    }
    .list-item{
        padding-left: 40px;
        padding-right: 40px;
        color: #707070;
    }
    .list-item-left{
        text-align: left;
    }
    .list-item-center{
        text-align: center;
    }
    .list-item-right{
        text-align: right;
    }
    .load-more{
        padding-top: 5px;
        display: flex;
    }
    .verified-img{
        width: 20px;
    }
    .load-more-button{
        color: #707070;
    }
</style>